import React from 'react';
import { PropTypes } from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import './styles.scss';

const ModalComponent = ({ children, ...props }) => {
	return (
		<Dialog
			PaperProps={{
				style: {
					backgroundColor: 'transparent',
					color: 'black',
					boxShadow: 'none',
				},
			}}
			open={props.open}
			onClose={() => {}}
			{...props}
			aria-labelledby='customized-dialog-title'
		>
			<DialogContent>{children}</DialogContent>
		</Dialog>
	);
};

ModalComponent.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ModalComponent.defaultProps = {
	children: null,
};

export default ModalComponent;
